import { IMFASettings, UserAttribute } from '@core/services';

export enum MFATypes {
  SMS = 'SMS_MFA',
  Token = 'SOFTWARE_TOKEN_MFA',
  Custom = 'CUSTOM_CHALLENGE',
}

export interface ChangePasswordPayload {
  newPassword: string;
  oldPassword: string;
  accessToken?: string;
}

export interface ConfirmSignInPayload {
  code: string;
  mfaType: MFATypes;
}

export type ConfirmSignInResponse = Record<string, any>;

export interface NewUserPayload {
  newPassword: string;
  requiredAttributeData?: any;
}

export type NewUserResponse = Record<string, any>;

export type PasswordResetCodeResponse = Record<string, any>;

export interface ResetPasswordPayload {
  newPassword: string;
  resetCode: string;
}

export interface SignInUser {
  password: string;
  username: string;
}

export type SignInResponse = Record<string, any>;

export type SendPasswordResetCodeResponse = Record<string, any>;

export interface SetMFAPreferencePayload {
  smsSettings: IMFASettings;
  tokenSettings: IMFASettings;
}

export type UpdateUserAttributesPayload = UserAttribute[];

export interface VerifyAttributePayload {
  attributeName: string;
  confirmationCode: string;
}
